import { css } from "@emotion/react";
import { CSSProperties } from "react";

export interface DataTableTheme {
    dataTableTheme?: {
        typography: {
            core: string;
            subdued: string;
            moreSubdued: string;
            lessSubdued: string;
        };
        background: string;
        root: {
            border: string;
        };
        header: {
            background: string;
            bottomBorder: string;
        };
        selected: {
            rowBackgroundColour: string;
            rowBorder: string;
            cellBackgroundColour: string;
            cellBorderColour: string;
            cellRangeBackgroundColour: string;
        };
        unSelected: {
            borderColor: string;
        };
        alternateRows?: {
            backgroundColour: {
                firstRow: string;
                secondRow: string;
            };
        };
        buttons: {
            primary: {
                background: string;
                text: string;
            };
            secondary: {
                background: string;
                text: string;
            };
        };
        checkBox: {
            checked: {
                tick: {
                    color: string;
                    /** Font Aweseome Solid (fas) or Font Awesome Regular (far) */
                    weight: "fas" | "far";
                };
                border: string;
                background: string;
            };
            unchecked: {
                border: string;
                background: string;
            };
            cell: {
                colour: string;
            };
        };
        popover: {
            boxShadow: string;
            borderRadius: CSSProperties["borderRadius"];
        };
        validation: {
            invalidCellColour: string;
        };
        icons: {
            color: string;
        };
        chips: {
            background: string;
        };
        additionalCss?: ReturnType<typeof css>;
    };
}
